import _ from 'lodash';
import { DEFAULT_MEDIA_QUERY_PLATFORMS, COMPONENT_STATES, COMPONENT_TYPE as TYPE } from 'common/constants';
import View from 'client/components/common/BuildingBlocks/Img/Img';

import pic1 from 'assets/images/pic1.jpeg';
import pic2 from 'assets/images/pic2.jpeg';
import pic3 from 'assets/images/pic3.jpeg';
import pic4 from 'assets/images/pic4.jpeg';
import pic5 from 'assets/images/pic5.jpeg';
import { generateElementId, generateNodeId } from 'client/components/common/BuildingBlocks/utils/common';

const pictures = [pic1, pic2, pic3, pic4, pic5];

export const IMG = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.IMG,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: IMG.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, IMG.displayName),
				},
				componentProps: {
					styles: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								backgroundImage: `url("${pictures[_.random(0, pictures.length - 1)]}")`,
							},
						},
					},
					other: {},
				},
			},
			children: [],
		},
	};
};

IMG.displayName = 'Image';
